import { useState } from 'react';

export default function SocialMediaCTA() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqs = [
    {
      question: "Wie lange dauert es, bis ich erste Ergebnisse sehe?",
      answer: "Erste Ergebnisse sind oft schon nach 2-4 Wochen sichtbar. Organisches Wachstum und nachhaltige Erfolge entwickeln sich typischerweise über 3-6 Monate. Bei bezahlter Werbung können Sie bereits nach wenigen Tagen erste Resultate erwarten."
    },
    {
      question: "Welche Social Media Plattformen sind für mein Unternehmen am besten?",
      answer: "Das hängt von Ihrer Zielgruppe und Ihren Zielen ab. Instagram eignet sich hervorragend für visuelle Inhalte und jüngere Zielgruppen, LinkedIn für B2B-Marketing, Facebook für eine breite Reichweite und TikTok für kreative, virale Inhalte. Wir analysieren Ihre Zielgruppe und empfehlen die optimalen Plattformen."
    },
    {
      question: "Erstellen Sie auch die Inhalte für meine Social Media Kanäle?",
      answer: "Ja, wir bieten Full-Service Social Media Management. Das umfasst Content-Erstellung, Grafikdesign, Videoproduktion, Copywriting und Community Management. Sie können sich entspannt zurücklehnen, während wir Ihre Online-Präsenz aufbauen."
    },
    {
      question: "Wie messen Sie den Erfolg meiner Social Media Kampagnen?",
      answer: "Wir verwenden detaillierte Analytics und KPIs wie Reichweite, Engagement-Rate, Website-Traffic, Lead-Generierung und Conversions. Sie erhalten monatliche Reports mit allen wichtigen Kennzahlen und Optimierungsempfehlungen."
    },
    {
      question: "Kann ich die Inhalte vor der Veröffentlichung genehmigen?",
      answer: "Selbstverständlich! Wir erstellen einen Content-Plan und senden Ihnen alle Inhalte zur Freigabe. Sie haben die volle Kontrolle über das, was in Ihrem Namen veröffentlicht wird. Änderungswünsche setzen wir gerne um."
    },
    {
      question: "Wie oft sollte ich auf Social Media posten?",
      answer: "Die optimale Posting-Frequenz hängt von der Plattform ab. Für Instagram empfehlen wir 4-7 Posts pro Woche, für Facebook 3-5 Posts, LinkedIn 2-3 Posts und TikTok täglich. Wichtiger als die Häufigkeit ist jedoch die Qualität und Relevanz der Inhalte."
    }
  ];

  return (
    <section id="faq" className="py-24 bg-black">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center space-x-3 text-[#d1bc8a] mb-6">
              <div className="w-2 h-2 bg-[#d1bc8a] rounded-full animate-pulse"></div>
              <span className="text-sm uppercase tracking-wider">FAQ</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Häufig gestellte
              <span className="block text-[#d1bc8a]">
                Fragen
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Hier finden Sie Antworten auf die wichtigsten Fragen rund um unser Social Media Marketing. 
              Haben Sie weitere Fragen? Kontaktieren Sie uns gerne!
            </p>
          </div>

          {/* FAQ Items */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full p-6 text-left flex items-center justify-between hover:bg-[#d1bc8a]/5 transition-colors cursor-pointer"
                >
                  <h3 className="text-lg font-semibold text-white pr-4">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-[#d1bc8a] text-xl transition-transform duration-300`}></i>
                  </div>
                </button>
                
                {openFAQ === index && (
                  <div className="px-6 pb-6">
                    <div className="border-t border-zinc-800 pt-4">
                      <p className="text-gray-400 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div className="text-center mt-12">
            <a
              href="/kontakt"
              className="inline-block bg-[#d1bc8a] hover:bg-[#c4af7d] text-black py-4 px-8 rounded-xl font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-2xl transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Weitere Fragen? Jetzt Kontakt aufnehmen
            </a>
          </div>

          {/* Contact Info */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className="text-center">
              <div className="w-12 h-12 bg-[#d1bc8a] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-black text-xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2">Telefon</h3>
              <p className="text-gray-400">017645725863</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-[#d1bc8a] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-black text-xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2">E-Mail</h3>
              <p className="text-gray-400">bamme.media@gmail.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-[#d1bc8a] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-black text-xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2">Antwortzeit</h3>
              <p className="text-gray-400">Innerhalb von 24h</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}